// extracted by mini-css-extract-plugin
export default {"page":"email-templates_page__cvM0i","container":"email-templates_container__B-AV0"};